import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Form, Input, Select, Space, Spin, Table, Typography, message, Alert } from "antd";
import { IconNotFound } from "../../icons/IconNotFound";
import ThreatVaultModal from "./ThreatVaultModal";
import { useDispatch, useSelector } from "react-redux";
import { getDataArrayThreat, getDataArrayThreatSha, getDataIdThreat } from "../../store/threatvault";
import { getTVaultArrData, getTVaultArrDataSha, getTvaultErrors, getTVaultIdData, getTvaultLoader } from "../../store/threatvault/selectors";
import ThreatVaultCardCveNew from "./ThreatVaultCardCveNew";
import ThreatVaultCardShaNew from "./ThreatVaultCardShaNew";
import PreloaderNew from "../UI/PreloaderNew/PreloaderNew";

const { Title, Text } = Typography;
const styleNoMargin = { margin: 0 };

function ThreatVaultAreaNew() {
    const [messageApi, contextHolder] = message.useMessage();
    const isLoader = useSelector(getTvaultLoader);
    const errors = useSelector(getTvaultErrors)
    const dispatch = useDispatch()
    const [type, setType] = useState("id");

    const [modalItem, setModalItem] = useState(-1);
    const threatArrData = useSelector(getTVaultArrData);
    const threatArrDataSha = useSelector(getTVaultArrDataSha);
    const threatIdData = useSelector(getTVaultIdData);
    const [dataView, setDataView] = useState(false);

    const changeSelectType = (value) => {

        const lowerCaseValue = value.toLowerCase().trim();
        if (!isNaN(lowerCaseValue)) setType('id');
        if (lowerCaseValue.includes('cve')) setType('cve');
        if (lowerCaseValue.length === 32) setType('md5');
        if (lowerCaseValue.length === 64) setType('sha256');

    }

    const getItemById = async (itemID) => {
        dispatch(getDataIdThreat(itemID));;
        setModalItem(itemID);
    }

    return (


        <Space direction="vertical" size={20} style={{ width: "100%" }}>
            {contextHolder}

            <Title level={3} style={styleNoMargin}>Threat Vault</Title>
            {errors && errors!=='По вашему запросу ничего не найдено.'&&<Alert
                        message="Error"
                        description={errors}
                        type="error"
                        showIcon
                    />}
            <ConfigProvider theme={{
                components: {
                    Select: { controlHeight: 44 },
                    Input: { controlHeight: 44 },
                    Button: { controlHeight: 44 },
                    Form: { margin: 0 },
                }
            }}>
                <Form
                    requiredMark={false}
                    layout="inline"
                    style={{
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 200px",
                        gap: 20, position: "relative"
                    }}
                    onFinish={({ search }) => {

                        if (type === 'id' || type === 'cve') {
                            dispatch(getDataArrayThreat({ name: search, type: type }));
                        }
                        else dispatch(getDataArrayThreatSha({ name: search, type: type }))
                    }}
                    initialValues={{ type }}
                >
                    {isLoader && <PreloaderNew />}
                    <Form.Item >
                        <Text>Поиск</Text>
                        <Form.Item name="search" rules={[{ required: true, message: "Пожалуйста, введите значение!" }]}>
                            <Input

                                onChange={(evt) => changeSelectType(evt.target.value)}
                                placeholder="Например: 38419 или CVE-2002-1310"
                            />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item >
                        <Text>Тип</Text>
                        <Select
                            onChange={(evt) => { setType(evt) }}

                            style={{ height: 44 }}

                            value={type}
                            options={[
                                { value: "id", label: "ID Сигнатуры" },
                                { value: "cve", label: "Номер CVE" },
                                { value: "sha256", label: "sha256" },
                                { value: "md5", label: "Md5" },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item style={{ marginTop: '21.89px' }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ width: "100%", background: '#2E496F' }}
                            disabled={isLoader ? true : false}
                        >
                            Поиск
                        </Button>
                    </Form.Item>
                </Form>
            </ConfigProvider>

            {errors === 'По вашему запросу ничего не найдено.' &&
                <Space
                    direction="vertical"
                    size={24}
                    style={{
                        color: "#2E496F",
                        alignItems: "center",
                        display: "flex",
                        marginTop: 24,
                    }}
                >

                    <IconNotFound />
                    <div>По вашему запросу ничего не найдено. Попробуйте другой запрос</div>
                </Space>}
            {threatArrData && <ThreatVaultCardCveNew data={threatArrData?.result} getItemById={getItemById} />}
            {threatArrDataSha && <ThreatVaultCardShaNew data={threatArrDataSha?.result} getItemById={getItemById} />}
            <ThreatVaultModal open={modalItem >= 0} close={() => setModalItem(-1)} />
        </Space>

    )

}

export default ThreatVaultAreaNew;